import {create} from 'zustand';

type PartsListStoreVariables = {
  showAdminFeatures: boolean;
  partsWithActionQty: number[];
};

type PartsListStoreFunctions = {
  toggleAdminFeatures: () => void;
  addPartWithActionQty: (value: number) => void;
  removePartWithActionQty: (value: number) => void;
};

type PartsListStore = PartsListStoreVariables & PartsListStoreFunctions;

const DEFAULT_VALUE: PartsListStoreVariables = {
  showAdminFeatures: false,
  partsWithActionQty: [],
};

export const usePartsListStore = create<PartsListStore>((set) => {
  const toggleAdminFeatures = () => {
    set((state) => ({
      showAdminFeatures: !state.showAdminFeatures,
    }));
  };

  return {
    ...DEFAULT_VALUE,
    toggleAdminFeatures,
    addPartWithActionQty: (value) => {
      set((state) => ({
        partsWithActionQty: state.partsWithActionQty.includes(value)
          ? state.partsWithActionQty.filter((part) => part !== value)
          : [...state.partsWithActionQty, value],
      }));
    },
    removePartWithActionQty: (value) => {
      set((state) => ({
        partsWithActionQty: state.partsWithActionQty.filter(
          (part) => part !== value,
        ),
      }));
    },
  };
});
